import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const SortByNumber = ({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 18 18' {...props}>
    <Path
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M5.75 14.997 4.003 13.25M7.39 13.352l-1.65
       1.65M5.758 3v11.997M12.75 7.5V3h-1.5M11.25 7.5h3M14.25 12a1.5 1.5 0 0 0-3 0v1.5a1.5 1.5 0 0 0 3 0V12Z'
    />
  </IconBase>
)

SortByNumber.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default SortByNumber
